import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import { Image } from 'react-bootstrap';

export default function TestDrive()
{
    return (
        <>
            <section className="hero-reseller d-flex align-items-center text-white">
                <div className="container hero-inner">
                    <div className="hero-copy">
                        <h1>See How Instant Polls Works</h1>
                        <p>
                            Experience Instant Polls in action, and watch how you can create your first poll in minutes.
                        </p>
                    </div>
                </div>
            </section>

            <section className="position-relative ">
                <div id="content" className="flex-grow-1">
                    <div className="container-fluid p-0">
                        <div className="row bg-white rounded p-2 ms-0 me-2">
                            <div className="col-12">
                                <div className="video-wrapper">
                                    <video
                                        controls
                                        preload="metadata"
                                        poster="/video-thumbnail.jpg"
                                    >
                                        <source
                                            src="https://instant-polls.syd1.cdn.digitaloceanspaces.com/videos/instantpolls-intro.mp4"
                                            type="video/mp4"
                                        />
                                    </video>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

TestDrive.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;